import { render, staticRenderFns } from "./PageStructureSection.vue?vue&type=template&id=03d18877&"
import script from "./PageStructureSection.vue?vue&type=script&lang=ts&"
export * from "./PageStructureSection.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureSection.vue?vue&type=style&index=0&id=03d18877&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports